<template>
  <tr>
    <th :class="{ form_line_l: hasClosingLine }" />
    <td :class="{ form_line_r: hasClosingLine }">
      <p>{{ $t('contactGuidance.text') }}</p>
    </td>
  </tr>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ContactGuidanceRow',
  props: {
    // 表の最後の行として使うときに、締めの線（form_line_l / form_line_r）を付ける
    hasClosingLine: {
      type: Boolean,
      required: true,
    },
  },
})
</script>
